export class UnreachableCaseError extends Error {
  constructor(value) {
    super(`Unreachable case: ${JSON.stringify(value)}`);
    this.errorType = 'UnreachableCaseError';
  }
}